import request from '@/utils/request'
// 获取banner列表
export function getBannerlist(data) {
  return request({
    url:'/factivity/v100/getAdvertiseList',
    method:'post',
    data:data
  })
}
// 根据城市名称获取城市id
export function cityPosit(data) {
  return request({
    url:'/filmapi/city/cityPosit',
    method:'post',
    data:data
  })
}
// 影片--热映
export function hotList(data) {
  return request({
    url:'/filmapi/film/getHotList',
    method:'post',
    data:data
  })
}
// 影片--即将上映
export function movieList(data) {
  return request({
    url:'/filmapi/film/getComingList',
    method:'post',
    data:data
  })
}
// 影片--想看
export function addLikeFilm(data) {
  return request({
    url:'/filmaccount/film/addLikeFilm',
    method:'post',
    data:data
  })
}
// 影片--取消想看
export function delLikeFilm(data) {
  return request({
    url:'/filmaccount/film/delLikeFilm',
    method:'post',
    data:data
  })
}
// 影片--影片详情
export function getFilmDetail(data) {
  return request({
    url:'/filmapi/film/getFilmDetail',
    method:'post',
    data:data
  })
}
// 排期--获取影院详情
export function getCinemaDetail(data) {
  return request({
    url:'/filmapi/cinema/getShowCinemaDetail',
    method:'post',
    data:data
  })
}
// 排期--获取活动详情
export function getShowActivityDetail(data) {
  return request({
    url:'/factivity/v100/getActivity',
    method:'post',
    data:data
  })
}
// 排期--获取影片列表
export function getShowFilmList(data) {
  return request({
    url:'/filmapi/film/getShowFilmList',
    method:'post',
    data:data
  })
}
// 排期--获取场次时间列表
export function getDateShowList(data) {
  return request({
    url:'/filmapi/show/getCinemaShowList',
    method:'post',
    data:data
  })
}
// 座位--查询未支付订单信息
export function qryUnOrderStatus(data) {
  return request({
    url:'/filmorders/orders/qryUnOrderStatus',
    method:'post',
    data:data
  })
}
// 座位--座位释放
export function releaseSeat(data) {
  return request({
    url:'/filmorders/orders/releaseSeat',
    method:'post',
    data:data
  })
}
// 座位--获取排期信息
export function getShowDetail(data) {
  return request({
    url:'/filmapi/show/getShowDetail',
    method:'post',
    data:data
  })
}
// 座位--获取接口座位
export function getShowSeatList(data) {
  return request({
    url:'/filmapi/seat/getShowSeatList',
    method:'post',
    data:data
  })
}
// 座位--锁座
export function getlock(data) {
  return request({
    url:'/filmorders/orders/getlock',
    method:'post',
    data:data
  })
}



// WEBPACK FOOTER //
// ./src/api/film.js